import * as Yup from 'yup';

const signUpFormValidationShape = {
  firstName: Yup.string()
    .test('firstName', 'Please enter your first name.', (value) => {
      if (!value) return true;
      const valueWithoutMask = value.replace(/\D+/g, '');
      return valueWithoutMask.length <= 2;
    })
    .max(20, 'Must be 20 characters or fewer.')
    .required('Please enter your first name.'),
  lastName: Yup.string()
    .test('lastName', 'Please enter your last name.', (value) => {
      if (!value) return true;
      const valueWithoutMask = value.replace(/\D+/g, '');
      return valueWithoutMask.length <= 2;
    })
    .max(20, 'Must be 20 characters or fewer.')
    .required('Please enter your last name.'),
  originalUrl: Yup.string().required('Please upload an image.'),
  emailAddress: Yup.string()
    .email('Please enter a valid email address.')
    .max(100, 'Must be 100 characters or fewer.')
    .required('Please enter a valid email address.'),
  zipCode: Yup.string()
    .test('zipCode', 'Please enter a valid ZIP code.', (value) => {
      if (!value) return true;
      const valueWithoutMask = value.replace(/\D+/g, '');
      return valueWithoutMask.length === 5;
    })
    .required('Please enter a valid ZIP code.'),
  provider: Yup.string().max(40, 'Must be 40 characters or fewer.'),
  ageConfirmation: Yup.bool()
    .test('ageConfirmation', 'Please check this box to continue.', (value) => value === true)
    .required('Please check this box to continue.'),
  agreeToRules: Yup.bool()
    .test('agreeToRules', 'Please check this box to continue.', (value) => value === true)
    .required('Please check this box to continue.'),
};

export const SignUpFormValidationSchema = Yup.object().shape(signUpFormValidationShape);
